(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-popup"] && !Shopify.designMode) return;
  try {
    // Store product modal data for use when modal opens
  document.addEventListener('DOMContentLoaded', function () {
    // Get all "Learn More" buttons
    const learnMoreButtons = document.querySelectorAll('[data-product-popup]');
    const modal = document.getElementById('productModal');
    const closeButton = modal.querySelector('.product-modal__close-button');
    const overlay = modal.querySelector('.product-modal__overlay');

    // Function to open modal with product data
    function openModal(productEl) {
      // Get product data
      const productTitle = productEl.querySelector('[data-product-title]').textContent;
      const productImage = productEl.querySelector('[data-product-image] img').src;
      const modalDescription = productEl.querySelector('.card-description-hidden').innerHTML;

      // Find the current block
      const currentBlock = productEl.closest('[data-product-block]');

      // Set modal content
      modal.querySelector('.product-modal__title').textContent = productTitle;
      modal.querySelector('.product-modal__image').src = productImage;
      modal.querySelector('.product-modal__image').alt = productTitle;
      modal.querySelector('.product-modal__description').innerHTML = modalDescription;

      // Show modal
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    // Function to close modal
    function closeModal() {
      modal.classList.remove('is-active');
      document.body.style.overflow = ''; // Restore scrolling
    }

    // Attach click event to all Learn More buttons
    learnMoreButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const productEl = this.closest('[data-product-block]');
        openModal(productEl);
      });
    });

    // Close modal when clicking close button
    closeButton.addEventListener('click', closeModal);

    // Close modal when clicking overlay
    overlay.addEventListener('click', closeModal);

    // Close modal when pressing ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
